import { render, staticRenderFns } from "./PaginatedList.vue?vue&type=template&id=e42f0b88&"
import script from "./PaginatedList.vue?vue&type=script&lang=js&"
export * from "./PaginatedList.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports